<template>
  <div>
    <div class="text-h5 mb-5">
      Receiving Items
    </div>
    <ListStockItemCheckSheets />
    <div class="text-h5 mt-5 mb-5">
      <v-btn color="success" v-if="selected.length > 0" @click="batch">
        <v-icon left>{{ mdiCheckCircleOutline }}</v-icon> Batch Items
      </v-btn> Factory Items
    </div>
    <ListActiveProcessCheckSheets
      :statusList="statusList"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  mdiContentSave, mdiPencil, mdiDelete, mdiMagnify, mdiFactory,
} from '@mdi/js';
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import ListStockItemCheckSheets from '../components/ListStockItemCheckSheets.vue';
import ListActiveProcessCheckSheets from '../components/ListActiveProcessCheckSheets.vue';

export default {
  name: 'ListVerify',
  module: 'StockItem',
  components: { ListStockItemCheckSheets, ListActiveProcessCheckSheets },
  mixins: [loading],
  data() {
    return {
      mdiContentSave,
      mdiPencil,
      mdiDelete,
      mdiFactory,
      mdiMagnify,
      search: '',
      selected: [],
      statusList: ['Ready to be verified', 'Ready for NRCS'],
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('stockItems', ['stockItems']),
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockItems', ['LOAD_availableStockItems', 'DELETE_stockItem', 'UPDATE_stockItem', 'MERGE_stockItems']),
    async mergeStockItems() {
      const result = await this.$confirm('Are you sure you want to merge these items?');
      if (result) {
        this.isLoading = true;
        const { selected } = this;
        const mergeStockItemModel = selected.map((s) => s.id);
        console.log(selected);
        await this.MERGE_stockItems({ stockItemIds: mergeStockItemModel });
        await this.$nextTick();
        await this.LOAD_availableStockItems();
        this.isLoading = false;
      }
    },
    async processStockItem(stockItem) {
      this.isLoading = true;
      const { id } = stockItem;
      await this.UPDATE_stockItem({
        id,
        state: 'Processing',
        productionDate: dayjs(new Date()).add(1, 'day').toDate(),
      });
      await this.LOAD_availableStockItems();
      this.isLoading = false;
    },
    /** Delete StockItem from the collection
     */
    async remove(StockItem) {
      const result = await this.$confirm(this.$t('common.phrases.confirmDelete'));
      if (result) {
        this.isLoading = true;
        await this.DELETE_stockItem(StockItem.id);
        this.isLoading = false;
      }
    },
  },
};
</script>

<docs>
# StockItem example

'''js
<StockItem />
'''
</docs>
